// extracted by mini-css-extract-plugin
export default {"UserThumb":"IiKIW","imageNotLoaded":"F_Apt"};